import { Routes as ReactRouterRoutes, Route, Navigate } from 'react-router-dom';

import NotFound from '../../pages/NotFound';

import DossierPage from '../../pages/DossierPage';
import CommandePage from '../../pages/CommandePage';
import StockInventairePage from '../../pages/StockInventairePage';
import InventaireDetailPage from '../../pages/InventaireDetailPage';
import AdministrationPage from '../../pages/AdministrationPage';
import ConsoleReglesPage from '../../pages/ConsoleReglesPage';
import NotificationPage from '../../pages/NotificationPage';
import SubmitRulePage from '../../pages/SubmitRulePage/SubmitRulePage';

const Routes = () => {
  return (
    <ReactRouterRoutes>
      <Route path="/" element={<Navigate to="/dossier" replace />} />
      <Route path="/dossier" element={<DossierPage />} />
      <Route path="/commande" element={<CommandePage />} />
      <Route path="/stock" element={<StockInventairePage />} />
      <Route path="/inventaire" element={<StockInventairePage />} />
      <Route path="/inventaire/:reference" element={<InventaireDetailPage />} />
      <Route path="/administration" element={<AdministrationPage />} />
      <Route path="/administration/console-regles" element={<ConsoleReglesPage />} />
      <Route
        path="/administration/console-regles/publication"
        element={<SubmitRulePage />}
      />
      <Route path="/administration/notification" element={<NotificationPage />} />
      <Route path="*" element={<NotFound />} />
    </ReactRouterRoutes>
  );
};

export default Routes;
